'use client'

import type { VippsButtonProps } from '@maestro/commerce-blocks/components/vipps-button/vipps-button.types'

import classNames from 'classnames'
import React from 'react'

import { vippsFont } from '@/styles/fonts'
import { useVippsButton } from '@maestro/commerce-blocks/components/vipps-button/use-vipps-button'
import { Button } from '@pearlconvert/ui/components/button'

import '@maestro/commerce-blocks/components/vipps-button/styles/vipps-button.scss'

export default function VippsButton(props: VippsButtonProps) {
  const {
    // Vipps-specific props
    redirectTo,
    onSuccess,
    onError,
    providerId = 'vipps',
    // Button props with defaults
    type,
    size = 'normal',
    disabled = false,
    className = '',
    children,
    // Ignore onClick as we override it
    onClick: _ignoredOnClick,
    ...restButtonProps
  } = props

  const { handleVippsAuth, isSigningIn } = useVippsButton({
    redirectTo,
    onSuccess,
    onError,
    providerId,
  })

  return (
    <Button
      {...restButtonProps}
      type={type}
      size={size}
      disabled={disabled || isSigningIn.current}
      className={classNames('vipps-button', className, vippsFont.variable)}
      onClick={handleVippsAuth}
      buttonType="button"
      isLoading={isSigningIn.current}
    >
      {children}
    </Button>
  )
}
